import { Component, Input } from '@angular/core';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';

@Component({
	selector: 'main-shoot-date',
	template: require('./main-shoot-date.html')
})
export class MainShootDateComponent {
	@Input('start-date') startDate;
	@Input('finish-date') finishDate;
	@Input('fromQuote') fromQuote?;

	constructor(private timeService: TimeServiceProvider) {}

	setStartDateFilter() {
		const isYearsEqual = this.timeService.compareYears(
			this.startDate,
			this.finishDate
		);
		const isDatesDifferent = this.timeService.compareDates(
			this.startDate,
			this.finishDate
		);

		const onlyYearsAreEqual = isYearsEqual && isDatesDifferent;

		if (onlyYearsAreEqual) {
			return this.fromQuote ? 'dayAndLongMonth' : 'dayAndMonth';
		}

		return this.fromQuote ? 'long' : 'medium';
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/main-shoot-date/main-shoot-date.ts